/**
 * 仕様書 0422 §10.4 の禁止語 13 語。
 * BE 側の LLM 出力にもフィルタが入っているが、FE 側でも管理者の入力（プロンプト本文・
 * 同意文書本文・コメント等）を検査して、保存前に注意喚起できるようにする
 */
export const FORBIDDEN_WORDS: readonly string[] = [
  '診断',
  'うつ',
  '症状',
  '発症',
  '患者',
  '障害',
  '疾患',
  '病気',
  '病名',
  '治療',
  '処方',
  '鬱',
  'メンタル不調',
] as const;

export interface ForbiddenWordHit {
  word: string;
  /** マッチ位置（0-based） */
  index: number;
  /** 前後 10 文字を含む抜粋 */
  snippet: string;
}

/**
 * 与えられたテキストから禁止語を検出する。空文字なら空配列。
 * 同じ語が複数回出現する場合は最初の 1 件だけ返す（軽量化と UI 上の見やすさのため）
 */
export function findForbiddenWords(text: string | null | undefined): ForbiddenWordHit[] {
  if (!text) return [];
  const hits: ForbiddenWordHit[] = [];
  const seen = new Set<string>();
  for (const word of FORBIDDEN_WORDS) {
    if (seen.has(word)) continue;
    const idx = text.indexOf(word);
    if (idx === -1) continue;
    seen.add(word);
    const start = Math.max(0, idx - 10);
    const end = Math.min(text.length, idx + word.length + 10);
    hits.push({ word, index: idx, snippet: text.slice(start, end) });
  }
  return hits;
}
